package com.catbit.opinionpoll.core.data.models

data class LatLong(
    val latitude: Double,
    val longitude: Double
) {
    override fun toString() = "$latitude,$longitude"
}
